export const getXPositionRelativeTo = (
  element1: Element,
  element2: Element,
) => {
  const rect1 = element1.getBoundingClientRect();
  const rect2 = element2.getBoundingClientRect();
  const relativeX = rect1.left - rect2.left;
  return relativeX;
};

export const isInputElement = (
  el: Element | null | undefined,
): el is HTMLInputElement => el?.tagName === "INPUT";

// https://stackoverflow.com/a/76535387
export const getScrollParent = (node: Element): Element => {
  const isScrollable = (node: Element) => {
    if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
      return false;
    }
    const style = getComputedStyle(node);
    return ["overflow", "overflow-x", "overflow-y"].some((propertyName) => {
      const value = style.getPropertyValue(propertyName);
      return value === "auto" || value === "scroll";
    });
  };
  let currentParent = node.parentElement;
  while (currentParent) {
    if (isScrollable(currentParent)) {
      return currentParent;
    }
    currentParent = currentParent.parentElement;
  }
  return document.scrollingElement || document.documentElement;
};
